function abortableFetch(request: string, opts = {}) {
  const controller = new globalThis.AbortController();

  return {
    abort: () => controller.abort(),
    ready: globalThis?.fetch?.(request, { ...opts, signal: controller.signal }),
  };
}

export default abortableFetch;
